// Nombre de lignes blanches (deals) maximum par slide inventaire, a caler sur
// ce qui tient dans une slide standard (les lignes colorees ne comptent pas).
export const MAX_INVENTORY_ROWS_PER_SLIDE = 28;

export const flattenInventoryRows = (vizInfo) => {
  if (!vizInfo?.tree?.by_fund) {
    return [];
  }

  const rows = [];

  vizInfo.tree.by_fund.forEach((fundNode) => {
    fundNode.by_deal_status
      .filter((statusNode) => !statusNode.portfolio.is_empty)
      .forEach((statusNode) => {
        if (fundNode.fund.reporting_split_by_deal_type) {
          statusNode.by_round_type
            .filter((roundTypeNode) => !roundTypeNode.portfolio.is_empty)
            .forEach((roundTypeNode) => {
              roundTypeNode.by_deal
                .filter((dealNode) => !dealNode.portfolio.is_empty)
                .forEach((dealNode) => {
                  dealNode.by_asset_type
                    .filter((assetTypeNode) => !assetTypeNode.portfolio.is_empty)
                    .forEach((assetTypeNode) => {
                      rows.push({
                        type: "deal",
                        portfolio: assetTypeNode.portfolio,
                        previous_portfolio: assetTypeNode.previous_portfolio,
                        asset_type: assetTypeNode.asset_type,
                      });
                    });
                });
              rows.push({ type: "spacer" });
              rows.push({
                type: "roundTypeSubtotal",
                portfolio: roundTypeNode.portfolio,
                previous_portfolio: roundTypeNode.previous_portfolio,
                round_type: roundTypeNode.round_type,
              });
              rows.push({ type: "spacer" });
            });
        } else {
          statusNode.by_deal
            .filter((dealNode) => !dealNode.portfolio.is_empty)
            .forEach((dealNode) => {
              dealNode.by_asset_type
                .filter((assetTypeNode) => !assetTypeNode.portfolio.is_empty)
                .forEach((assetTypeNode) => {
                  rows.push({
                    type: "deal",
                    portfolio: assetTypeNode.portfolio,
                    previous_portfolio: assetTypeNode.previous_portfolio,
                    asset_type: assetTypeNode.asset_type,
                  });
                });
            });
        }
      });

    rows.push({
      type: "fund",
      portfolio: fundNode.portfolio,
      previous_portfolio: fundNode.previous_portfolio,
      fund: fundNode.fund,
    });
  });

  rows.push({ type: "spacerBottom" });

  return rows;
};

// Seules les lignes blanches (deals) comptent dans le budget d'une slide :
// les sous-totaux round-type et le total fonds (lignes colorees) ainsi que les
// spacers ne sont pas comptes.
const countsTowardLimit = (row) => row.type === "deal";

const isBreakable = (row) =>
  row.type === "deal" || row.type === "roundTypeSubtotal";

const isSpacer = (row) => row.type === "spacer" || row.type === "spacerBottom";

export const paginateInventoryRows = (
  rows,
  maxRows = MAX_INVENTORY_ROWS_PER_SLIDE,
) => {
  const pages = [];
  let current = [];
  let count = 0;

  rows.forEach((row) => {
    // On ne coupe que devant une ligne blanche (deal) ou un sous-total ; le
    // total fonds reste toujours avec les deals qu'il agrege.
    const breakBefore = count >= maxRows && isBreakable(row);

    if (breakBefore) {
      pages.push(current);
      current = [];
      count = 0;
    }

    // Drop spacers that would lead a page — they only make sense between rows.
    if (isSpacer(row) && current.length === 0) {
      return;
    }

    current.push(row);
    if (countsTowardLimit(row)) {
      count += 1;
    }
  });

  if (current.length > 0) {
    pages.push(current);
  }

  return pages.length > 0 ? pages : [[]];
};
